// extracted by mini-css-extract-plugin
export default {"title":"sVoR4WJs6W10qj_6Xz0N","paperingOutAlert":"lc9I9RzDPaunpijrRax8"};